import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import CategoriesPurchasedTable from './CategoriesPurchasedTable';
import ProductUnitsPurchasedTable from './ProductUnitsPurchasedTable';
import VIPTrendsPointsLocationTable from './VIPTrendsPointsLocationTable';
import VIPTrendsSalesLogsTable from './VIPTrendsSalesLogsTable';
import VIPTrendsVipCustomersTable from './VIPTrendsVipCustomersTable';
import SalesLogDialog from './SalesLogDialog';
import ReactToPrint from 'react-to-print';
import {convertDate, displayDateRangeString, toCurrency} from '../shared/functions';
import {getGetHeaders} from '../shared/serverFunctions';
import {createTableRow, populateCategoryTable, populateProductUnitTable} from '../shared/reportTableFunctions';
import {RESOURCES as reportsResources} from '../fuseVIPTrendsReportsResourceMap';
import '../shared/react-table.css';
import {tableStyles} from '../shared/styles-table';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import Config from '../messages';

/**
 * Class for retrieving and displaying VIP data for multiple tables
 *
 */
class VIPTrendsReportSet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allowLocationSelection: true,
            allowLoyaltySelection: true,
            dataIsFiltered: false,
            dataSet1Complete: false,
            errorMessage1: null,
            errorMessage2: null,
            errorMessage3: null,
            headerSet1: {
                type: null,
                choice: null
            },
            headerSet2: {
                id: null,
                name: null,
                city: null,
                state: null
            },
            headerSet3: {
                first_name: null,
                id: null,
                last_name: null,
                city: null,
                state: null,
                zip: null
            },
            hideArea1: false,
            loadingData1: props.showLoading,
            loadingData2: false,
            loadingData3: false,
            locationCountValid: true,
            selectedLocation: {
                id: null,
                name: null,
                dba_name: null,
                city: null,
                selected: false,
                state: null,
                type: null,
                zipcode: null
            },
            selectedLoyalty: {
                id: null
            },
            selectedSequence: null,
            tableSet1Categories: [],
            tableSet1Locations: [],
            tableSet2Categories: [],
            tableSet2Customers: [],
            tableSet2Products: [],
            tableSet3Categories: [],
            tableSet3Logs: [],
            tableSet3Products: []
        };
        this.area2Position = null;
        this.area3Position = null;
        this.handleLocationSelect = this.handleLocationSelect.bind(this);
        this.handleLoyaltySelect = this.handleLoyaltySelect.bind(this);
        this.handleSalesSeqSelect = this.handleSalesSeqSelect.bind(this);
    }

    componentWillMount() {
        this.fetchData('all');
    }

    componentWillReceiveProps(nextProps) {
        let clearData = false;
        // If initial date range or filter choices change, reset
        if (
            nextProps.startDate !== this.props.startDate ||
            nextProps.endDate !== this.props.endDate ||
            nextProps.offset !== this.props.offset ||
            nextProps.filterChoiceFirst !== this.props.filterChoiceFirst ||
            nextProps.filterChoiceSecond !== this.props.filterChoiceSecond ||
            nextProps.filterType !== this.props.filterType ||
            nextProps.showLoading !== this.props.showLoading
        ) {
            clearData = true;
        }
        if (clearData) {
            this.setState({
                allowLocationSelection: true,
                allowLoyaltySelection: true,
                dataSet1Complete: false,
                errorMessage1: null,
                errorMessage2: null,
                errorMessage3: null,
                loadingData1: nextProps.showLoading,
                loadingData2: false,
                loadingData3: false,
                selectedLocation: {
                    id: null,
                    name: null,
                    dba_name: null,
                    city: null,
                    selected: false,
                    state: null,
                    type: null,
                    zipcode: null
                },
                selectedLoyalty: {
                    id: null
                },
                tableSet1Categories: [],
                tableSet1Locations: [],
                tableSet2Categories: [],
                tableSet2Customers: [],
                tableSet2Products: [],
                tableSet3Categories: [],
                tableSet3Logs: [],
                tableSet3Products: []
            });
        }
    }

    componentDidUpdate(prevProps) {
        let dataTypeToFetch = 'none';
        if (
            prevProps.startDate !== this.props.startDate ||
            prevProps.endDate !== this.props.endDate ||
            prevProps.offset !== this.props.offset ||
            (prevProps.filterType !== 'all' && this.props.filterType === 'all')
        ) {
            dataTypeToFetch = 'all';
        }
        if (
            prevProps.filterChoiceFirst !== this.props.filterChoiceFirst ||
            prevProps.filterChoiceSecond !== this.props.filterChoiceSecond ||
            prevProps.totalFiltersAvailable !== this.props.totalFiltersAvailable
        ) {
            if (this.props.totalFiltersAvailable === 2) {
                dataTypeToFetch = (this.props.filterChoiceSecond) ? 'filter' : 'none';
            } else if (this.props.totalFiltersAvailable === 1) {
                dataTypeToFetch = 'filter';
            }
        }
        if (dataTypeToFetch === 'filter') {
            this.fetchData(prevProps.filterType);
        } else if (dataTypeToFetch === 'all') {
            this.fetchData('all');
        }
    }

    /* API Calls ------------------------------ */

    /**
     * Get filtered data by a specific date range
     *
     * @param dataType
     * @param selectedValue
     */
    fetchData(dataType, selectedValue = null) {
        const params = {
            start_date: this.props.startDate,
            end_date: this.props.endDate,
            offset: this.props.offset,
        };

        // Update parameters and set resource based on data filter
        let resource;
        let reportName = 'VIP Trends';

        let firstFilterValue, secondFilterValue;
        if (dataType !== 'all') {
            if (this.props.filterChoiceFirst) {
                firstFilterValue = this.props.filterChoiceFirst;
            }
            if (this.props.filterChoiceSecond) {
                secondFilterValue = this.props.filterChoiceSecond;
            }
        }
        let dataIsFiltered = (dataType !== 'all');
        let locationId = (this.state.selectedLocation && this.state.selectedLocation.id) ? this.state.selectedLocation.id : null;
        let loyaltyId = (this.state.selectedLoyalty && this.state.selectedLoyalty.id) ? this.state.selectedLoyalty.id : null;

        // Do not continue if filter choices are not available due to Primary/Secondary toggling, or if a selection is missing
        if (dataType !== 'all' && !firstFilterValue && !locationId && !loyaltyId) {
            return;
        }

        // Set additional params and select API path based on data type
        switch (dataType) {
            case 'location_count' :
                // Retrieve totals before calling for dataset
                params.location_id = this.state.selectedLocation.id;
                resource = reportsResources.VIPTrendsCount.GET_LIST(params);
                reportName = 'Location Count';
                break;
            case 'selected_location' :
                // Select Location ID in area 1: Retrieve data
                params.location_id = locationId;
                resource = reportsResources.VIPTrendsByLocation.GET_LIST(params);
                reportName = 'Location ' + locationId;
                break;
            case 'selected_loyalty' :
                // Select Loyalty Account ID from area 3: Retrieve data
                params.loyalty_id = loyaltyId;
                resource = reportsResources.VIPTrendsByLoyalty.GET_LIST(params);
                reportName = 'Loyalty Account ' + loyaltyId;
                break;
            case 'statecity':
                // Filter: State and City
                params.state = firstFilterValue;
                params.city = secondFilterValue;
                resource = reportsResources.VIPTrendsByStateCity.GET_LIST(params);
                reportName = 'VIP Trends by State and City';
                break;
            case 'statedba':
                // Filter: State and DBA
                params.state = firstFilterValue;
                params.dba_id = secondFilterValue;
                resource = reportsResources.VIPTrendsByStateDba.GET_LIST(params);
                reportName = 'VIP Trends by State and DBA';
                break;
            case 'dba':
                // Filter: DBA
                params.dba_id = firstFilterValue;
                resource = reportsResources.VIPTrendsByDba.GET_LIST(params);
                reportName = 'VIP Trends by DBA';
                break;
            case 'district':
                // Filter: District
                params.district_id = firstFilterValue;
                resource = reportsResources.VIPTrendsByDistrict.GET_LIST(params);
                reportName = 'VIP Trends by District';
                break;
            case 'location':
                // Filter: Location
                params.location_id = firstFilterValue;
                resource = reportsResources.VIPTrendsByLocation.GET_LIST(params);
                reportName = 'VIP Trends by Location ' + firstFilterValue;
                break;
            case 'state':
                // Filter: State
                params.state = firstFilterValue;
                resource = reportsResources.VIPTrendsByState.GET_LIST(params);
                reportName = 'VIP Trends by State';
                break;
            case 'all':
                // Filter: All
                resource = reportsResources.VIPTrendsAll.GET_LIST(params);
                break;
            default:
                // Get all data
                resource = reportsResources.VIPTrendsAll.GET_LIST(params);
                break;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data && result.data.payload) {
                if (dataType === 'location_count') {
                    // Check totals for Location before retrieving data
                    let countType = 'filtered';
                    if (this.state.selectedLocation.type === 'selected') {
                        countType = 'selected';
                    }
                    this.checkLocationCount(countType, this.state.selectedLocation.id, result.data.payload);

                } else if (dataType === 'selected_location') {
                    // Process results for a selected Location ID
                    this.processLocationData(locationId, result.data.payload);

                } else if (dataType === 'selected_loyalty') {
                    // Process results for a selected Loyalty Account
                    this.processLoyaltyData(loyaltyId, result.data.payload);

                } else {
                    // Process results for date range with optional filter
                    this.processData(dataType, dataIsFiltered, result.data.payload);
                }
            }
        }).catch((error) => {
            let message = Config.fuse.error.error + reportName + '.';
            let errorMessage1 = null;
            let errorMessage2 = null;
            let errorMessage3 = null;
            if (error.response) {
                // Server response outside 2xx
                if (error.response.data && error.response.data.error) {
                    message = Config.fuse.error.error + reportName + ': ' + error.response.data.error;
                }
            } else if (error.request) {
                // No response
                message = Config.fuse.error.no_response + reportName + '.';
            } else {
                console.log('Error', error.message);
            }
            if (dataType === 'selected_loyalty') {
                errorMessage3 = message;
            } else if (dataType === 'selected_location') {
                errorMessage2 = message;
            } else {
                errorMessage1 = message;
            }
            this.setState({
                errorMessage1: errorMessage1,
                errorMessage2: errorMessage2,
                errorMessage3: errorMessage3,
                loadingData1: false,
                loadingData2: false,
                loadingData3: false
            });
        });
    }

    /* Data Processing ------------------------------ */

    /**
     * Check Location result totals before retrieving data for selected or filtered Location
     *
     * @param type
     * @param id
     * @param data
     */
    checkLocationCount(type, id, data) {

        let locationCountValid = true;
        let aggs = data.aggregations;
        if (aggs) {
            let loyalty_customers_count = (
                aggs.loyalty_customers_count &&
                aggs.loyalty_customers_count.value
            )
                ? data.aggregations.loyalty_customers_count.value : 0;
            let products_returned = (
                aggs.products_returned &&
                aggs.products_returned.products_returned_count &&
                aggs.products_returned.products_returned_count.value
            )
                ? aggs.products_returned.products_returned_count.value : 0;
            let products_sold = (
                aggs.products_sold &&
                aggs.products_sold.products_sold_count &&
                aggs.products_sold.products_sold_count.value
            )
                ? aggs.products_sold.products_sold_count.value : 0;

            // If any result count would pass 10k, prevent the call
            if (loyalty_customers_count > 9999 || products_returned > 9999 || products_sold > 9999) {
                locationCountValid = false;
            }
        }
        this.setState({
            locationCountValid: locationCountValid
        }, () => {
            // If the count is valid, proceed with the original call
            if (locationCountValid) {
                if (type === 'filtered') {
                    this.fetchData('location', id);
                }
                if (type === 'selected') {
                    this.fetchData('selected_location', id);
                }
            }
        });
    }

    /**
     * Process API results of Locations and Categories by Date Range (Table Set 1)
     *
     * @param dataType
     * @param dataIsFiltered
     * @param data
     */
    processData(dataType, dataIsFiltered, data) {

        // Create empty arrays for first table set
        let headerSet1 = {
            type: null,
            choice: null
        };
        let tableSet1Categories = [];
        let tableSet1Locations = [];
        let hideArea1 = false;
        const emptyCurrency = toCurrency(0);

        if (data.aggregations) {

            // Assemble filtered data for each Location row in Area 1: Total Points Spent and Earned
            if (data.aggregations.totals_by_location && data.aggregations.totals_by_location.buckets) {
                let lResults = data.aggregations.totals_by_location.buckets;
                let lTotal = lResults.length;
                if (lTotal) {
                    for (let i = 0; i < lTotal; i++) {
                        let lResult = lResults[i];
                        let location = lResult.column_name.hits.hits[0]._source.rxtxMsg.payload.location;
                        location.id = lResult.column_name.hits.hits[0]._source.rxtxMsg.payload.client.location;
                        let ptsSpent = 0;
                        let ptsSpentValue = emptyCurrency;
                        let subtotalRefunded = emptyCurrency;
                        let subtotalSpent = emptyCurrency;

                        if (lResult.payments && lResult.payments.pts_spent && lResult.payments.pts_spent.payment_subtotal.value) {
                            ptsSpent = lResult.payments.pts_spent.payment_subtotal.value;
                            ptsSpentValue = lResult.payments.pts_spent.payment_subtotal.value * 0.1;
                        }
                        if (lResult.payments && lResult.payments.subtotal_that_earned_pts && lResult.payments.subtotal_that_earned_pts.payment_subtotal.value) {
                            subtotalSpent = lResult.payments.subtotal_that_earned_pts.payment_subtotal.value;
                        }
                        if (lResult.credits && lResult.credits.refunds_that_return_pts && lResult.credits.refunds_that_return_pts.credits_subtotal.value) {
                            subtotalRefunded = lResult.credits.refunds_that_return_pts.credits_subtotal.value;
                        }
                        let netTotal = subtotalSpent - subtotalRefunded;

                        // Create a Location/Points row
                        let locationRow = createTableRow('location_points', location);
                        locationRow.net_total = (netTotal) ? toCurrency(netTotal, true) : emptyCurrency;
                        locationRow.pts_spent = (ptsSpent) ? toCurrency(ptsSpent / 100) : 0;
                        locationRow.pts_spent_value = (ptsSpentValue) ? toCurrency(ptsSpentValue, true) : emptyCurrency;
                        locationRow.subtotal_refunded = (subtotalRefunded) ? toCurrency(subtotalRefunded, true) : emptyCurrency;
                        locationRow.subtotal_spent = (subtotalSpent) ? toCurrency(subtotalSpent, true) : emptyCurrency;

                        // Add the row to the table
                        tableSet1Locations.push(locationRow);
                    }
                }
            }

            // If data is filtered by Location, store a single Location result
            if (dataType === 'location' && data.aggregations.column_name) {
                let aggs = data.aggregations;
                let location = aggs.column_name.hits.hits[0]._source.rxtxMsg.payload.location;
                location.id = aggs.column_name.hits.hits[0]._source.rxtxMsg.payload.client.location;
                let ptsSpent = 0;
                let ptsSpentValue = emptyCurrency;
                let subtotalRefunded = emptyCurrency;
                let subtotalSpent = emptyCurrency;

                if (aggs.payments && aggs.payments.pts_spent && aggs.payments.pts_spent.payment_subtotal.value) {
                    ptsSpent = aggs.payments.pts_spent.payment_subtotal.value;
                    ptsSpentValue = aggs.payments.pts_spent.payment_subtotal.value * 0.1;
                }
                if (aggs.payments && aggs.payments.subtotal_that_earned_pts && aggs.payments.subtotal_that_earned_pts.payment_subtotal.value) {
                    subtotalSpent = aggs.payments.subtotal_that_earned_pts.payment_subtotal.value;
                }
                if (aggs.credits && aggs.credits.refunds_that_return_pts && aggs.credits.refunds_that_return_pts.credits_subtotal.value) {
                    subtotalRefunded = aggs.credits.refunds_that_return_pts.credits_subtotal.value;
                }
                let netTotal = subtotalSpent - subtotalRefunded;

                // Create a Location/Points row
                let locationRow = createTableRow('location_points', location);
                locationRow.net_total = (netTotal) ? toCurrency(netTotal, true) : emptyCurrency;
                locationRow.pts_spent = (ptsSpent) ? toCurrency(ptsSpent / 100) : 0;
                locationRow.pts_spent_value = (ptsSpentValue) ? toCurrency(ptsSpentValue, true) : emptyCurrency;
                locationRow.subtotal_refunded = (subtotalRefunded) ? toCurrency(subtotalRefunded, true) : emptyCurrency;
                locationRow.subtotal_spent = (subtotalSpent) ? toCurrency(subtotalSpent, true) : emptyCurrency;

                // Add the row to the table
                tableSet1Locations.push(locationRow);
            }

            // Assemble data for the Category table in Area 1: Categories Purchased by VIP Customers
            tableSet1Categories = populateCategoryTable(data, this.props.offset);

            // Store data for the Area header for this table set
            if (dataIsFiltered && data.aggregations.column_name && data.aggregations.column_name.hits) {
                let dataPayload = data.aggregations.column_name.hits.hits[0]._source.rxtxMsg.payload;
                if (dataPayload && dataPayload.location) {
                    let loc = dataPayload.location;
                    // Set the header based on filter selection, if applicable
                    switch (dataType) {
                        case 'statecity':
                            headerSet1.type = 'City and State';
                            headerSet1.choice = loc.city + ', ' + loc.state;
                            break;
                        case 'statedba':
                            headerSet1.type = 'DBA and State';
                            headerSet1.choice = loc.dba.name + ', ' + loc.state;
                            break;
                        case 'dba':
                            headerSet1.type = 'DBA';
                            headerSet1.choice = loc.dba.name + ' (' + loc.dba.id + ')';
                            break;
                        case 'district':
                            headerSet1.type = 'District';
                            headerSet1.choice = loc.district.name + ' (' + loc.district.id + ')';
                            break;
                        case 'location':
                            headerSet1.type = 'Location';
                            headerSet1.choice = loc.name + ' (' + dataPayload.client.location + ')';
                            hideArea1 = true;
                            break;
                        case 'state':
                            headerSet1.type = 'State';
                            headerSet1.choice = loc.state;
                            break;
                        default:
                            break;
                    }
                }
            }
        }

        // Finalize API data and Points/Location table data
        this.setState({
            dataSet1Complete: true,
            errorMessage1: null,
            headerSet1: {
                type: headerSet1.type,
                choice: headerSet1.choice
            },
            hideArea1: hideArea1,
            loadingData1: false,
            tableSet1Categories: tableSet1Categories,
            tableSet1Locations: tableSet1Locations
        }, () => {
            this.props.onDataProcessed();
        });
    }

    /**
     * Process API results of Categories, Products and VIP Customers by selected Location in Date Range (Table Set 2)
     *
     * @param id
     * @param data
     */
    processLocationData(id, data) {

        // Create empty arrays for selected Location ID
        let headerSet2 = {
            id: null,
            name: null,
            city: null,
            state: null
        };
        let tableSet2Categories = [];
        let tableSet2Customers = [];
        let tableSet2Products = [];
        const emptyCurrency = toCurrency(0);

        if (data.aggregations) {

            // Assemble data for the Category table in Area 2: Categories Purchased by VIP Customers
            tableSet2Categories = populateCategoryTable(data, this.props.offset);

            // Assemble data for the Product Units table in Area 2: VIP Total Product Units Purchased
            tableSet2Products = populateProductUnitTable(data, this.props.offset);

            // Assemble data for the Customer table in Area 2: VIP Customers Report
            if (data.aggregations.by_loyalty_customers && data.aggregations.by_loyalty_customers.buckets) {
                let cResults = data.aggregations.by_loyalty_customers.buckets;
                let cTotal = cResults.length;
                if (cTotal) {
                    for (let c = 0; c < cTotal; c++) {
                        let cResult = cResults[c];
                        let customer = cResult.column_name.hits.hits[0]._source.rxtxMsg.payload.loyalty_customer;
                        let numSales = 0;
                        let ptsSpent = 0;
                        let ptsSpentValue = 0;
                        let subtotalSpent = emptyCurrency;

                        if (cResult.payments && cResult.payments.pts_spent && cResult.payments.pts_spent.payment_subtotal.value) {
                            ptsSpent = cResult.payments.pts_spent.payment_subtotal.value;
                            ptsSpentValue = cResult.payments.pts_spent.payment_subtotal.value * 0.1;
                        }
                        if (cResult.payments && cResult.payments.subtotal_that_earned_pts && cResult.payments.subtotal_that_earned_pts.payment_subtotal.value) {
                            subtotalSpent = cResult.payments.subtotal_that_earned_pts.payment_subtotal.value;
                        }
                        if (cResult.num_of_sales && cResult.num_of_sales.value) {
                            numSales = cResult.num_of_sales.value;
                        }

                        // Create a Customer row
                        let customerRow = createTableRow('customer', customer);
                        customerRow.num_sales = (numSales) ? numSales : 0;
                        customerRow.pts_spent = (ptsSpent) ? toCurrency(ptsSpent / 100) : 0;
                        customerRow.pts_spent_value = (ptsSpentValue) ? toCurrency(ptsSpentValue, true) : emptyCurrency;
                        customerRow.amount_spent_that_earned_points = (subtotalSpent) ? toCurrency(subtotalSpent, true) : emptyCurrency;

                        // Add the row to the table
                        tableSet2Customers.push(customerRow);
                    }
                }
            }

            // Store data for the Area header for this table set
            if (data.aggregations.column_name && data.aggregations.column_name.hits) {
                let dataPayload = data.aggregations.column_name.hits.hits[0]._source.rxtxMsg.payload;
                if (dataPayload && dataPayload.location) {
                    let loc = dataPayload.location;
                    headerSet2.id = dataPayload.client.location;
                    headerSet2.name = loc.name;
                    headerSet2.city = loc.city;
                    headerSet2.state = loc.state;
                }
            }
        }

        // Finalize VIP Customers by Location table data
        this.setState({
            allowLocationSelection: true,
            allowLoyaltySelection: true,
            errorMessage2: null,
            headerSet2: {
                id: headerSet2.id,
                name: headerSet2.name,
                city: headerSet2.city,
                state: headerSet2.state
            },
            loadingData2: false,
            tableSet2Categories: tableSet2Categories,
            tableSet2Customers: tableSet2Customers,
            tableSet2Products: tableSet2Products
        });
    }

    /**
     * Process API results of Categories, Products and Sales Logs by selected Loyalty Account in Date Range (Table Set 3)
     *
     * @param id
     * @param data
     */
    processLoyaltyData(id, data) {
        // Create empty arrays for selected Loyalty Account ID
        let headerSet3 = {
            first_name: null,
            id: null,
            last_name: null,
            city: null,
            state: null,
            zip: null
        };
        let tableSet3Categories = [];
        let tableSet3Logs = [];
        let tableSet3Products = [];
        const emptyCurrency = toCurrency(0);

        if (data.aggregations) {

            // Assemble data for the Category table in Area 3: Categories Purchased by VIP Customers
            tableSet3Categories = populateCategoryTable(data, this.props.offset);

            // Assemble data for the Product Units table in Area 3: VIP Total Product Units Purchased
            tableSet3Products = populateProductUnitTable(data, this.props.offset);

            // Assemble data for the Sales Logs table in Area 3: Sales Logs by (VIP ID)
            if (data.aggregations.sales_log && data.aggregations.sales_log.buckets) {
                let sResults = data.aggregations.sales_log.buckets;
                let sTotal = sResults.length;
                if (sTotal) {
                    for (let s = 0; s < sTotal; s++) {
                        let sResult = sResults[s];
                        let saleItem = {};
                        let sale = sResult.column_name.hits.hits[0]._source.rxtxMsg.payload;
                        let initialTaxes = (sale.initial_tax) ? Number(sale.initial_tax) : 0;
                        let initialAdditionalTaxes = (sale.initial_additional_taxes) ? Number(sale.initial_additional_taxes) : 0;
                        let totalTaxes = initialTaxes + initialAdditionalTaxes;

                        saleItem.transaction_date = (sale.transaction_date) ? sale.transaction_date : 'No Date';
                        saleItem.transaction_date_string = (sale.transaction_date)
                            ? convertDate(sale.transaction_date, 'display', true, true, this.props.offset, true)
                            : 'No Date';
                        saleItem.sale_seq = sResult.column_name.hits.hits[0]._id;
                        saleItem.mode = (sale.mode) ? sale.mode : 'live';
                        saleItem.initial_net = (sale.initial_net) ? toCurrency(sale.initial_net, true) : emptyCurrency;
                        saleItem.initial_tax = (totalTaxes) ? toCurrency(totalTaxes, true) : emptyCurrency;
                        saleItem.initial_total = (sale.initial_total) ? toCurrency(sale.initial_total, true) : emptyCurrency;
                        saleItem.location = (sale.client && sale.client.location) ? sale.client.location : '----';
                        saleItem.register = (sale.client && sale.client.register) ? sale.client.register : '--';
                        saleItem.user = (sale.client && sale.client.user) ? sale.client.user : '----';
                        saleItem.version = (sale.client && sale.client.version) ? sale.client.version : 'None';

                        // Create a Customer row
                        let salesLogRow = createTableRow('sales_log', saleItem);

                        // Add the row to the table
                        tableSet3Logs.push(salesLogRow);
                    }
                }
            }

            // Store data for the Area header for this table set
            if (data.aggregations.column_name && data.aggregations.column_name.hits) {
                let dataPayload = data.aggregations.column_name.hits.hits[0]._source.rxtxMsg.payload;
                if (dataPayload && dataPayload.loyalty_customer) {
                    let loyaltyCustomer = dataPayload.loyalty_customer;
                    headerSet3.first_name = loyaltyCustomer.first_name;
                    headerSet3.id = loyaltyCustomer.id;
                    headerSet3.last_name = loyaltyCustomer.last_name;
                    headerSet3.city = loyaltyCustomer.city;
                    headerSet3.state = loyaltyCustomer.state;
                    headerSet3.zip = loyaltyCustomer.zip;
                }
            }
        }

        // Finalize VIP Customer Report by Loyalty Customer table data
        this.setState({
            allowLocationSelection: true,
            allowLoyaltySelection: true,
            errorMessage3: null,
            headerSet3: {
                first_name: headerSet3.first_name,
                id: headerSet3.id,
                last_name: headerSet3.last_name,
                city: headerSet3.city,
                state: headerSet3.state,
                zip: headerSet3.zip
            },
            loadingData3: false,
            tableSet3Categories: tableSet3Categories,
            tableSet3Logs: tableSet3Logs,
            tableSet3Products: tableSet3Products
        });
    }

    /**
     * Store selected Location and make calls
     *
     * @param event
     * @param row
     */
    handleLocationSelect(event, row) {
        const location = {
            id: row.location_id,
            name: row.location_name,
            dba_name: row.dba_name,
            city: row.city,
            selected: true,
            state: row.state,
            type: 'selected',
            zipcode: row.zipcode
        };
        this.setState({
            allowLocationSelection: false,
            allowLoyaltySelection: false,
            loadingData2: true,
            selectedLocation: location,
            selectedLoyalty: {
                id: null
            }
        }, () => {
            this.scrollToArea(2);
            // Check totals for Location before retrieving data
            this.fetchData('location_count', location.id);
        });
    }

    /**
     * Store selected Loyalty Account and make calls
     *
     * @param event
     * @param row
     */
    handleLoyaltySelect(event, row) {
        const loyalty = {
            id: row.customer_id
        };
        this.setState({
            allowLocationSelection: false,
            allowLoyaltySelection: false,
            loadingData3: true,
            selectedLoyalty: loyalty
        }, () => {
            this.scrollToArea(3);
            this.fetchData('selected_loyalty', loyalty.id);
        });
    }

    /**
     * Trigger Dialog for selected Sales Sequence
     *
     * @param event
     * @param seq
     */
    handleSalesSeqSelect(event, seq) {
        this.setState({
            selectedSequence: seq
        });
    }

    /**
     * Handle event from Dialog closure
     */
    handleDialogReset = () => {
        this.setState({
            selectedSequence: null
        });
    };

    scrollToArea(area) {
        if (area === 2) {
            window.scrollTo(0, this.area2Position.offsetTop);
        }
        if (area === 3) {
            window.scrollTo(0, this.area3Position.offsetTop);
        }
    }

    render() {

        const {
            endDate,
            offset,
            startDate,
            system
        } = this.props;

        const {
            allowLocationSelection,
            allowLoyaltySelection,
            dataSet1Complete,
            errorMessage1,
            errorMessage2,
            errorMessage3,
            headerSet1,
            headerSet2,
            headerSet3,
            hideArea1,
            loadingData1,
            loadingData2,
            loadingData3,
            locationCountValid,
            selectedLocation,
            selectedLoyalty,
            selectedSequence,
            tableSet1Categories,
            tableSet1Locations,
            tableSet2Categories,
            tableSet2Customers,
            tableSet2Products,
            tableSet3Categories,
            tableSet3Logs,
            tableSet3Products
        } = this.state;

        return (
            <div>

                {loadingData1 &&
                <div className="loader-container">
                    <h4>Generating Reports...</h4>
                    <CircularProgress
                        size={24}
                        thickness={2}
                        className="loader"
                    />
                </div>
                }

                {dataSet1Complete &&
                <div>

                    {/* Area 1: VIP Trends by Date Range and Secondary Filter :::::::::::::::::::::::::::::::::::::::: */}

                    <div ref={e => (this.printRef1 = e)}>
                        {/* Report Header Set 1 */}
                        <div className="report-header">
                            <div className="btn-print-container report-header-button-container">
                                <ReactToPrint
                                    trigger={() =>
                                        <RaisedButton
                                            primary
                                            type="button"
                                            label="Print Report"
                                            style={tableStyles.printBtn}/>
                                    }
                                    content={() => this.printRef1}
                                />
                            </div>
                            <h2 className="report-header-title">VIP Trends Report</h2>
                            {headerSet1 && headerSet1.type &&
                            <p>
                                <strong>{headerSet1.type}</strong>: {headerSet1.choice}
                            </p>
                            }
                            <p>
                                {displayDateRangeString(startDate, endDate)}
                            </p>
                        </div>

                        {/* Report: Total VIP Points Spent and Earned (Locations) */}
                        <VIPTrendsPointsLocationTable
                            tableKey="set1"
                            listData={tableSet1Locations}
                            endDate={endDate}
                            startDate={startDate}
                            system={system}
                            allowLocationSelection={allowLocationSelection}
                            locationIconFunction={this.handleLocationSelect}
                        />

                        {/* Report: Categories */}
                        {!hideArea1 && tableSet1Categories.length > 0 &&
                        <CategoriesPurchasedTable
                            tableFilename="VIP-Customers-Categories"
                            tableKey="Set1"
                            tableLabel="Categories Purchased by VIP Customers"
                            listData={tableSet1Categories}
                            endDate={endDate}
                            startDate={startDate}
                            system={system}
                        />
                        }
                    </div>

                    {/* Area 2: VIP Customers by Selected Location :::::::::::::::::::::::::::::::::::::::: */}

                    <div ref={e => (this.printRef2 = e)}>
                        <div ref={(ref) => this.area2Position = ref}>
                        </div>

                        {selectedLocation.id && locationCountValid && loadingData2 &&
                        <div className="loader-container">
                            <h4>Generating Reports...</h4>
                            <CircularProgress
                                size={24}
                                thickness={2}
                                className="loader"
                            />
                        </div>
                        }
                        {!locationCountValid &&
                        <div>
                            <div style={tableStyles.error}>
                                <p>The selected Location has too many results.
                                    Please edit the Date Range filter to reduce the total results.</p>
                            </div>
                        </div>
                        }

                        {(tableSet2Categories.length > 0 || tableSet2Customers.length > 0 || tableSet2Products.length > 0) &&
                        <div className="margin-top">

                            {/* Report Header Set 2 */}
                            <div className="report-header">
                                <div className="btn-print-container report-header-button-container">
                                    <ReactToPrint
                                        trigger={() =>
                                            <RaisedButton
                                                primary
                                                type="button"
                                                label="Print Report"
                                                style={tableStyles.printBtn}/>
                                        }
                                        content={() => this.printRef2}
                                    />
                                </div>
                                <h2 className="report-header-title">VIP Customers Report</h2>
                                {headerSet2 && headerSet2.id &&
                                <p>
                                    <strong>Location</strong>: {headerSet2.id}<br/>
                                    {headerSet2.name &&
                                    <span>{headerSet2.name}<br/></span>
                                    }
                                    {headerSet2.city &&
                                    <span>{headerSet2.city}, </span>
                                    }
                                    {headerSet2.state &&
                                    <span>{headerSet2.state}</span>
                                    }
                                </p>
                                }
                                <p>
                                    {displayDateRangeString(startDate, endDate)}
                                </p>
                            </div>

                            {/* Report: Categories (by selected Location) */}
                            {tableSet2Categories.length > 0 &&
                            <CategoriesPurchasedTable
                                tableFilename="VIP-Customers-Categories"
                                tableKey="Set2"
                                tableLabel="Categories Purchased by VIP Customers"
                                listData={tableSet2Categories}
                                endDate={endDate}
                                startDate={startDate}
                                system={system}
                            />
                            }

                            {/* Report: Product Units */}
                            {tableSet2Products.length > 0 &&
                            <ProductUnitsPurchasedTable
                                tableFilename="VIP-Customers-Product-Units"
                                tableKey="Set2"
                                tableLabel="VIP Total Product Units Purchased"
                                listData={tableSet2Products}
                                endDate={endDate}
                                startDate={startDate}
                                system={system}
                            />
                            }

                            {/* Report: VIP Customers */}
                            {tableSet2Customers.length > 0 &&
                            <VIPTrendsVipCustomersTable
                                tableKey="set2"
                                tableLabel="VIP Customers Report"
                                listData={tableSet2Customers}
                                endDate={endDate}
                                startDate={startDate}
                                system={system}
                                allowLoyaltySelection={allowLoyaltySelection}
                                loyaltyIconFunction={this.handleLoyaltySelect}
                            />
                            }
                        </div>
                        }
                    </div>

                    {/* Error and Messaging for set 2: VIP Customers by Selected Location */}
                    {errorMessage2 &&
                        <div className="error">
                            <p>{errorMessage2}</p>
                        </div>
                    }

                    {/* Area 3: VIP Customer by Selected Loyalty Account :::::::::::::::::::::::::::::::::::::::: */}

                    <div ref={e => (this.printRef3 = e)}>
                        <div ref={(ref) => this.area3Position = ref}>
                        </div>

                        {selectedLoyalty.id && loadingData3 &&
                        <div className="loader-container">
                            <h4>Generating Reports...</h4>
                            <CircularProgress
                                size={24}
                                thickness={2}
                                className="loader"
                            />
                        </div>
                        }

                        {(tableSet3Categories.length > 0 || tableSet3Logs.length > 0 || tableSet3Products.length > 0) &&
                        <div className="margin-top">

                            {/* Report Header Set 3 */}
                            <div className="report-header">
                                <div className="btn-print-container report-header-button-container">
                                    <ReactToPrint
                                        trigger={() =>
                                            <RaisedButton
                                                primary
                                                type="button"
                                                label="Print Report"
                                                style={tableStyles.printBtn}/>
                                        }
                                        content={() => this.printRef3}
                                    />
                                </div>
                                <h2>
                                    {headerSet3 && headerSet3.id &&
                                    <span>{headerSet3.id}</span>
                                    }
                                    &nbsp;Customer Report
                                </h2>
                                <p>
                                    <strong>Customer</strong>: {headerSet3.id}<br/>
                                    {headerSet3.first_name && headerSet3.last_name &&
                                    <span>{headerSet3.first_name} {headerSet3.last_name}<br/></span>
                                    }
                                    {headerSet3.city &&
                                    <span>{headerSet3.city}, </span>
                                    }
                                    {headerSet3.state &&
                                    <span>{headerSet3.state}</span>
                                    }
                                    {headerSet3.zip &&
                                    <span> {headerSet3.zip}</span>
                                    }
                                </p>
                                <p>
                                    {displayDateRangeString(startDate, endDate)}
                                </p>
                            </div>

                            {/* Report: Categories (by selected Loyalty Account) */}
                            {tableSet3Categories.length > 0 &&
                            <CategoriesPurchasedTable
                                tableFilename="VIP-Customers-Categories"
                                tableKey="Set3"
                                tableLabel="Categories Purchased by VIP Customers"
                                listData={tableSet3Categories}
                                endDate={endDate}
                                startDate={startDate}
                                system={system}
                            />
                            }

                            {/* Report: Product Units */}
                            {tableSet3Products.length > 0 &&
                            <ProductUnitsPurchasedTable
                                tableFilename="VIP-Customers-Product-Units"
                                tableKey="Set3"
                                tableLabel="VIP Total Product Units Purchased"
                                listData={tableSet3Products}
                                endDate={endDate}
                                startDate={startDate}
                                system={system}
                            />
                            }

                            {/* Report: Sales Logs */}
                            {tableSet3Logs.length > 0 &&
                            <VIPTrendsSalesLogsTable
                                tableKey="set3"
                                tableLabel={`Sales Logs by ${headerSet3.id}`}
                                listData={tableSet3Logs}
                                endDate={endDate}
                                startDate={startDate}
                                system={system}
                                logSelectFunction={this.handleSalesSeqSelect}
                            />
                            }
                        </div>
                        }
                    </div>

                    {/* Error and Messaging for set 3: VIP Customer by Selected Loyalty Account */}
                    {errorMessage3 &&
                        <div className="error">
                            <p>{errorMessage3}</p>
                        </div>
                    }

                </div>
                }

                {/* Error and Messaging for set 1: VIP Trends by Date Range and Secondary Filter */}
                {errorMessage1 &&
                    <div className="error">
                        <p>{errorMessage1}</p>
                    </div>
                }

                {/* Sales Log Dialog (triggered by Sequence ID click */}
                <SalesLogDialog
                    sequence={selectedSequence}
                    offset={offset}
                    includeReceipt={true}
                    onCloseDialog={this.handleDialogReset}
                />
            </div>
        )
    }
}

VIPTrendsReportSet.propTypes = {
    addField: PropTypes.bool,
    endDate: PropTypes.string,
    filterChoiceFirst: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.object,
        PropTypes.string,
    ]),
    filterChoiceSecond: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.object,
        PropTypes.string,
    ]),
    filterType: PropTypes.string,
    offset: PropTypes.string.isRequired,
    onDataProcessed: PropTypes.func,
    showLoading: PropTypes.bool,
    startDate: PropTypes.string,
    system: PropTypes.string,
    totalFiltersAvailable: PropTypes.number,
};

VIPTrendsReportSet.defaultProps = {
    addField: true,
    endDate: null,
    filterChoiceFirst: null,
    filterChoiceSecond: null,
    filterType: 'all',
    offset: null,
    showLoading: false,
    startDate: null,
    totalFiltersAvailable: 0,
};

const enhance = compose(
    connect()
);

export default enhance(VIPTrendsReportSet);



// WEBPACK FOOTER //
// ./src/Fuse/components/VIPTrendsReportSet.js